import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import { useGenerateRefAndState, useScrollEndLoadMore } from "@/utils/useHooks";
import Message from "@/components/Message/index";
import { newPath, EmailHost, debounce } from '@/utils/index'
import { getCenterList, getTypes } from '@/api/index'
import { Spin, ButtonLoading } from "@/components/Loading";
import SvgsCommons from "@/components/svgs/commons";
import SvgsSubscription from "@/components/svgs/subscription";
import PageEmpty from "@/components/empty";
import ImgUser from "@/static/images/user.png";
import { useSlidePrevAndNext, passedStatus } from './utils'
import { Ecosystem } from './css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  const [currentType, setCurrentType, currentTypeRef] = useGenerateRefAndState(-1)
  const [types, setTypes, typesRef] = useGenerateRefAndState([])
  const [firstLoading, setFirstLoading, firstLoadingRef] = useGenerateRefAndState(true)
  const [reQuery, setReQuery, reQueryRef] = useGenerateRefAndState(0)
  const [apps, setApps, appRef] = useGenerateRefAndState([])
  const totalRef = useRef(0)
  const pageRef = useRef(0)
  const stopLoadMore = useRef(false)

  const toSub = (app) => () => {
    window.open(`${EmailHost}/sub/${app.nft}`)
  }

  const getApps = async (searchText) => {
    const _type = currentTypeRef.current
    const { list, total } = await getCenterList(_type === -1 ? '' : _type, searchText, pageRef.current)
    if (total === undefined) {
      Message.error('Failed to fetch data.');
    }
    totalRef.current = total
    if (!list.length) {
      return []
    }
    let _list = pageRef.current === 0 ? list : [...appRef.current, ...list]
    _list = _list.map((item) => {
      let tags = []
      if (item.type && ['number', 'string'].includes(typeof item.type)) {
        tags = typeof item.type === 'string' ? item.type.split(',') : [item.type]
      }
      return {
        ...item,
        tags,
      }
    })
    return _list
  }
  const getAndDealList = async (searchText) => {
    if (!typesRef.current.length) {
      const types = await getTypes()
      if (Array.isArray(types)) {
        types.unshift({ name: 'All', value: -1 })
        setTypes(types)
      }
    }
    let list = await getApps(searchText)
    setFirstLoading(false)
    if (!searchText && list.length) {
      pageRef.current += 1
    }
    list = list.map((item) => {
      let tags = []
      if (Array.isArray(item.tags) && Array.isArray(typesRef.current)) {
        tags = item.tags.map((_value) => {
          const fTypes = typesRef.current.filter(({ value }) => value == _value)
          return fTypes.length ? fTypes[0] : null
        }).filter(item => !!item)
      }
      return {
        ...item,
        tags,
      }
    })
    setApps(list)
  }
  const loadMoreFn = async () => {
    if (stopLoadMore.current) {
      return
    }
    if (totalRef.current <= appRef.current.length) {
      return
    }

    await getAndDealList()
  }

  useScrollEndLoadMore(null, loadMoreFn, 50)

  useEffect(() => {
    getAndDealList()
  }, [reQuery])

  const onSearch = debounce((ev) => {
    setCurrentType(-1)
    setApps([])
    totalRef.current = 0
    pageRef.current = 0
    setFirstLoading(true)
    stopLoadMore.current = ev.target.value ? true : false
    getAndDealList(ev.target.value || '')
  })

  const onType = (value) => ev => {
    setCurrentType(value)
    setApps([])
    totalRef.current = 0
    pageRef.current = 0
    setFirstLoading(true)
    setReQuery(reQueryRef.current + 1)
    stopLoadMore.current = false
  }
  const typesDomRef = useRef(null)
  const [typesLeft, onTypesPrev, onTypesNext, currentTypeScrollToView] = useSlidePrevAndNext(typesDomRef)
  useEffect(() => {
    currentTypeScrollToView()
  }, [currentType])

  return (
    <Ecosystem className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[1].name} />
      <div className="center">
        <div className="breadcrumbs">
          <a onClick={() => history.push(`${newPath}/`)}>Home</a>/<span>Subscription Center</span>
        </div>
        <div className="title">
          {isMobile ? null : <h1>Subscription Center</h1>}
          {/* <span>
            More than <strong>80</strong> developers joined
          </span> */}
          <div className="search">
            <SvgsCommons type="search" />
            <input type="text" placeholder='Search DApp' onInput={onSearch} />
          </div>
        </div>
        <div className="content">
          <div className="types">
            <p className="tprev" onClick={onTypesPrev}><SvgsCommons type="arrow" /></p>
            <div className="types-list">
              <div ref={typesDomRef} style={{ transform: `translateX(${typesLeft}px)` }}>
                {types.map(({ value, name }) => <span onClick={onType(value)} className={currentType === value ? 'on' : ''} key={value}>{ name }</span>)}
              </div>
            </div>
            <p className="tnext" onClick={onTypesNext}><SvgsCommons type="arrow" /></p>
          </div>
          <div className="app-list">
            <Spin loading={firstLoading} style={ { height: '100%' } }>
              {!apps.length ? <PageEmpty /> : (
                <ul>
                  {apps.map((app, index) => (
                    <li key={index} onClick={toSub(app)}>
                      <div className={`ava ${app.logo ? '' : 'default-ava'}`}>
                        <img src={app.logo || ImgUser} alt="" />
                      </div>
                      <div className="project">
                        <div className="flex">
                          <div className="name">
                            <h1>{app.name || '--'}{app.name && app.certifications == passedStatus ? <SvgsSubscription type="verified" width="16" /> : null}</h1>
                            <p>
                              {Array.isArray(app.tags) && app.tags.map(({ name, value }, key) => (
                                <span key={key}>{name}</span>
                              ))}
                            </p>
                          </div>
                        </div>
                        <div className="actions">
                          <a className="red-btn">
                            Subscribe
                          </a>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </Spin>
          </div>
        </div>
      </div>
    </Ecosystem>
  )
}

export default withRouter(inject("store")(observer(Index)))